/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Text,
} from 'native-base';
import testProps from '../functions/testProps';

export default function NoRecordsFound(props) {
	const text = props.text || 'No Records found.';
	return <Text
				{...testProps('NoRecordsFound')}
				flex={1}
				p={20}
			>{text}</Text>;
}